import React from 'react';

import { SmartLink } from 'components';

import TopTournamentLogo from '../TopTournamentLogo';
import useTopTournament from '../useTopTournament';
import './topTournamentRow.scss';

interface Props {
    tournamentId: string;
}

const TopTournamentRow: React.FC<Props> = ({ tournamentId }) => {
    const props = useTopTournament({ tournamentId });

    if (!props) return null;

    const { linkToTournament, name, logo } = props;

    return (
        <SmartLink styleName="container" to={linkToTournament}>
            <TopTournamentLogo logo={logo} />

            <div styleName="info">
                <div styleName="name">{name}</div>
            </div>
        </SmartLink>
    );
};

export default React.memo(TopTournamentRow);
